if (!customElements.get("atc-button")) {
    class ATCButton extends HTMLElement {
        constructor() {
            super();
            this.isLoading = false;
        }
    
        connectedCallback() {
            this.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                
                if (this.isLoading) return;
                
                let productID = parseInt(this.dataset.productId);
                this.addItemToCart({ items: [{ id: productID, quantity: 1}] });
            });
        }

        // ADD ITEM TO CART
        async addItemToCart(product) {
            this.setLoadingState(true);
            
            try {
                const response = await fetch(`${window.location.origin}/cart/add.js`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(product)
                });

                if (response.status === 200) {
                    const result = await response.json();
                    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: result }));
                    this.showSuccessState();
                } else {
                    const errorData = await response.json();
                    this.showErrorState(errorData.description || 'Failed to add item to cart.');
                }
            } catch (error) {
                console.error('Cart add error:', error);
                this.showErrorState('Network error. Please try again.');
            } finally {
                this.setLoadingState(false);
            }
        }

        setLoadingState(loading) {
            this.isLoading = loading;
            const svg = this.querySelector('svg');
            const hiddenText = this.querySelector('.visually-hidden');
            
            if (loading) {
                this.setAttribute('aria-disabled', 'true');
                this.classList.add('loading');
                if (svg) svg.style.display = 'none';
                if (hiddenText) hiddenText.textContent = 'Adding to cart...';
            } else {
                this.removeAttribute('aria-disabled');
                this.classList.remove('loading');
                if (svg) svg.style.display = 'block';
                if (hiddenText) hiddenText.textContent = 'Add to cart';
            }
        }

        showSuccessState() {
            const originalText = this.querySelector('.visually-hidden');
            if (originalText) originalText.textContent = 'Added to cart!';
            
            setTimeout(() => {
                if (originalText) originalText.textContent = 'Add to cart';
            }, 2000);
        }

        showErrorState(message) {
            const originalText = this.querySelector('.visually-hidden');
            if (originalText) originalText.textContent = message;
            
            setTimeout(() => {
                if (originalText) originalText.textContent = 'Add to cart';
            }, 3000);
        }
    }

    customElements.define("atc-button", ATCButton);
}